import React from 'react';
import type { DashboardList } from '@atlassian/jira-spa-apps-servicedesk-project-dashboards/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskProjectDashboardsList = lazyForPaint<typeof DashboardList>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-project-dashboards-dashboard-list", jiraSpaEntry: "async-servicedesk-project-dashboards-dashboard-list" */ '@atlassian/jira-spa-apps-servicedesk-project-dashboards'
		).then((module) => module.DashboardList),
	),
);

export const ProjectDashboardsList = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskProjectDashboardsList}
		pageId="spa-apps/servicedesk-project-dashboards-list"
		shouldShowSpinner
	/>
);
